import React from 'react';
import type {IntlShape} from 'react-intl';

export const useTexts = (intl: IntlShape, userNames: string[] = []) => {
    const {formatMessage} = intl;

    const firstUserNames = userNames.slice(0, -1);
    const lastUserName = userNames[userNames.length - 1];
    const andMessage = formatMessage({
        id: 'post_body.check_for_out_of_channel_mentions.link.and',
        defaultMessage: ' and ',
    });

    const description = formatMessage(
        {
            id: 'convert_group_to_channel.description',
            defaultMessage: "You're about to change this conversation with {users} to a private channel.",
        },
        {
            users: (
                <strong>
                    {firstUserNames.join(', ')}
                    {andMessage}
                    {lastUserName}
                </strong>
            ),
        },
    );
    const title = formatMessage({
        id: 'convert_group_to_channel.title',
        defaultMessage: 'Change to a private channel',
    });
    const confirmText = formatMessage({
        id: 'convert_group_to_channel.confirm',
        defaultMessage: 'Change',
    });
    const cancelText = formatMessage({
        id: 'channel_modal.cancel',
        defaultMessage: 'Cancel',
    });
    const label = formatMessage({
        id: 'channel_modal.name.label',
        defaultMessage: 'Channel name',
    });
    const urlLabel = formatMessage({
        id: 'url_input.label.url',
        defaultMessage: 'URL: ',
    });
    const doneBtnText = formatMessage({
        id: 'url_input.buttonLabel.done',
        defaultMessage: 'Done',
    });
    const editBtnText = formatMessage({
        id: 'url_input.buttonLabel.edit',
        defaultMessage: 'Edit',
    });
    const hint1 = formatMessage({
        id: 'convert_group_to_channel.hint1',
        defaultMessage: 'The history of correspondence will be saved and available to all participants',
    });
    const hint2 = formatMessage({
        id: 'convert_group_to_channel.hint2',
        defaultMessage: 'You can add new members without limitation',
    });
    const hint3 = formatMessage({
        id: 'convert_group_to_channel.hint3',
        defaultMessage: 'WorkFlow scripts, scheduled messages will be deleted',
    });
    const hint4 = formatMessage({
        id: 'convert_group_to_channel.hint4',
        defaultMessage: "The change can't be undone",
    });

    return {
        description,
        title,
        confirmText,
        cancelText,
        label,
        urlLabel,
        doneBtnText,
        editBtnText,
        hint1,
        hint2,
        hint3,
        hint4,
    };
};
